import { useEffect } from "react";

interface SEOProps {
    title: string;
    description: string;
    keywords?: string;
    canonical?: string;
}

/**
 * SEO component to update page metadata
 * Updates document title and meta description for each page
 */
export default function SEO({ title, description, keywords, canonical }: SEOProps) {
    useEffect(() => {
        // Update page title
        document.title = title;

        // Update or create meta description
        let metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute("content", description);
        } else {
            metaDescription = document.createElement("meta");
            metaDescription.setAttribute("name", "description");
            metaDescription.setAttribute("content", description);
            document.head.appendChild(metaDescription);
        }

        // Update or create meta keywords if provided
        if (keywords) {
            let metaKeywords = document.querySelector('meta[name="keywords"]');
            if (metaKeywords) {
                metaKeywords.setAttribute("content", keywords);
            } else {
                metaKeywords = document.createElement("meta");
                metaKeywords.setAttribute("name", "keywords");
                metaKeywords.setAttribute("content", keywords);
                document.head.appendChild(metaKeywords);
            }
        }

        // Update or create canonical URL if provided
        if (canonical) {
            let linkCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
            if (linkCanonical) {
                linkCanonical.href = canonical;
            } else {
                linkCanonical = document.createElement("link");
                linkCanonical.rel = "canonical";
                linkCanonical.href = canonical;
                document.head.appendChild(linkCanonical);
            }
        }

        // Update Open Graph tags
        let ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) {
            ogTitle.setAttribute("content", title);
        }

        let ogDescription = document.querySelector('meta[property="og:description"]');
        if (ogDescription) {
            ogDescription.setAttribute("content", description);
        }

        let ogUrl = document.querySelector('meta[property="og:url"]');
        if (ogUrl && canonical) {
            ogUrl.setAttribute("content", canonical);
        }

        // Update Twitter Card tags
        let twitterTitle = document.querySelector('meta[name="twitter:title"]');
        if (twitterTitle) {
            twitterTitle.setAttribute("content", title);
        }

        let twitterDescription = document.querySelector('meta[name="twitter:description"]');
        if (twitterDescription) {
            twitterDescription.setAttribute("content", description);
        }

        let twitterUrl = document.querySelector('meta[name="twitter:url"]');
        if (twitterUrl && canonical) {
            twitterUrl.setAttribute("content", canonical);
        }
    }, [title, description, keywords, canonical]);

    return null;
}
